import { combineReducers } from '@reduxjs/toolkit'
import { entryTypesReducer } from './entryTypes'
import { conditionTypesReducer } from './conditionTypes'
import { operationTypesReducer } from './operationTypes'

export default combineReducers({
  entryTypes: entryTypesReducer,
  conditionTypes: conditionTypesReducer,
  operationTypes: operationTypesReducer,
})
